import { MoreOutlined } from '@ant-design/icons';
import { Button, Dropdown, Typography } from 'antd';

import type { ModelProductItem } from '@app/api/Products';
import { ProductLeftover } from '@app/pages/Warehouses/components/ProductLeftover';
import { PRODUCTS_TABLE_MENU } from '@app/pages/Warehouses/Products/data/constants';
import type { GetColumnType } from '@app/pages/Warehouses/Products/types';
import { bigNumberToString } from '@app/utils/bigNumberToString';

import type { ColumnsType } from 'antd/es/table';

export const getColumns: GetColumnType = ({
  onEdit,
  onOpenGoodsUnits,
  onDelete,
  showDelete,
  onEditSalePrice,
}) => {
  const columns: ColumnsType<ModelProductItem> = [
    {
      title: 'Название',
      dataIndex: 'Name',
      key: 'Name',
      ellipsis: true,
      width: '50%',
      render: (text, row) => (
        <div className="Products__name">
          <div>{text}</div>
          {!!row.AmountAndUnits && (
            <Typography.Text type="secondary">
              {row.AmountAndUnits}
            </Typography.Text>
          )}
        </div>
      ),
    },
    {
      title: 'Цена закупки',
      dataIndex: 'PriceOfPurchaseS',
      key: 'PriceOfPurchaseS',
      minWidth: 100,
      render: (_: unknown, row: ModelProductItem) => {
        const start = bigNumberToString(row?.PriceOfPurchaseS);
        const end = bigNumberToString(row?.PriceOfPurchaseE);
        const showRange = !!end && !!start && end !== start;
        const text = showRange ? `${start} - ${end}` : start || end;
        return <span className="no-wrap-text">{text}</span>;
      },
    },
    {
      title: 'Цена продажи',
      dataIndex: 'PriceOfSaleS',
      key: 'PriceOfSaleS',
      minWidth: 100,
      render: (_: unknown, row: ModelProductItem) => {
        const start = bigNumberToString(row?.PriceOfSaleS);
        const end = bigNumberToString(row?.PriceOfSaleE);
        const showRange = !!end && !!start && end !== start;

        const text = showRange ? `${start} - ${end}` : start || end;

        return <span className="no-wrap-text">{text}</span>;
      },
    },

    {
      title: 'Количество',
      dataIndex: 'Count',
      key: 'Count',
      render: (text, row: ModelProductItem) => {
        if (!text) {
          return <span className="no-wrap-text">0</span>;
        }

        const color = row?.IsBelowCritical
          ? '#a8071a'
          : row?.IsBelowMinimal
          ? '#d48806'
          : undefined;

        return (
          <Button
            type="link"
            style={color ? { color } : undefined}
            onClick={() => onOpenGoodsUnits(row?.ProductId)}
          >
            <span
              className="no-wrap-text"
              style={color ? { color } : undefined}
            >
              {text}
            </span>
          </Button>
        );
      },
    },
    {
      title: 'Остаток массы / объема',
      dataIndex: 'AmountLeftover',
      key: 'AmountLeftover',
      minWidth: 180,
      render: (_: unknown, row: ModelProductItem) => (
        <ProductLeftover
          amount={row.AmountLeftover}
          hasCreditResidual={row.IsDeficit}
          unit={row.UnitsOfMeasurement}
        />
      ),
    },
    {
      title: null,
      key: 'actions',
      dataIndex: 'actions',
      width: 48,
      fixed: 'right',
      render: (_: unknown, row: ModelProductItem) => (
        <Dropdown
          placement="bottomLeft"
          menu={{
            items: PRODUCTS_TABLE_MENU.filter((item) =>
              item?.key === 'delete' ? showDelete : true
            ),
            onClick: ({ key }) => {
              if (key === 'edit') {
                onEdit(row?.ProductId);
              }
              if (key === 'delete') {
                onDelete(row);
              }
              if (key === 'edit-sale-price') {
                onEditSalePrice(row);
              }
            },
          }}
        >
          <Button icon={<MoreOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return columns;
};
